import { React, Component } from 'react'
import { IoIosArrowBack,  } from 'react-icons/io';
import { FaRegCopy } from "react-icons/fa";
import { Link, Redirect } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import QrCode from './qrcode.png'

class PaymentPix extends Component {
    constructor(props){
        super(props);

        this.state = {
            step: 3,
            tooltipText: 'Clique para copiar'
        }

        this.copyToClipboard = this.copyToClipboard.bind(this);
    }

    copyToClipboard(e){

        var input = document.getElementById("qrcode");
        input.focus();
        input.select();
        document.execCommand('copy');
        
        this.setState({
            tooltipText: 'Copiado!'
        })

    }

    render() {

        if(!localStorage.getItem("token")){
            return (
                <Redirect to="/" />
            )
        }

        return(
            <div>
                <Link to="/payment">
                    <div className="main-title">
                        <h2>Pagamento PIX</h2>
                        <p>Lorem ipsum dolor sit amet</p>
                        <IoIosArrowBack />
                    </div>
                </Link>

                <div className="mt-4">

                    <div className="text-center">
                        <img className="img-fluid mb-3" src={QrCode} />                
                    </div>
                    <p className="text-center mb-3">Código pix</p>
                    <div data-for="qrCodeTip" data-tip onClick={(e) => this.copyToClipboard(e)} className="barcode">
                        <p>814ece709765f0a8d097baa4745126a6a8066be9ade</p>
                        <input id="qrcode" value="814ece709765f0a8d097baa4745126a6a8066be9ade" />
                        <FaRegCopy  />
                    </div>
                    <ReactTooltip id="qrCodeTip" getContent={() => this.state.tooltipText} />

                    <p className="text-center">
                        <small>
                            Realize o pagamento do pix em até <strong>5 minutos</strong><br />
                            e clique no botão abaixo para verificação
                        </small>
                    </p>

                    <div className="row justify-content-center mt-4">
                        <a className="btn-default" href="#">Confirmar pagamento</a>
                    </div>
                </div>
            </div>
        )

    }
}

export default PaymentPix;